import React from 'react';
import { Link } from 'react-router-dom';
import Background from '../components/Background';
import Navbar from '../components/Navbar';
import { ABOUT_PARAGRAPHS, TEAM, DIRECTIONS, CONTACT } from '../content/landing';

export default function AboutPage() {
  return (
    <div style={{ minHeight: '100vh', position: 'relative' }}>
      <Background />

      <div style={{
        position: 'relative', zIndex: 1,
        maxWidth: '700px',
        margin:   '0 auto',
        padding:  'clamp(4rem, 10vh, 8rem) 1.5rem 6rem',
      }}>

        {/* Back home */}
        <Link to="/" style={{
          display:        'inline-block',
          fontFamily:     'var(--font-body)',
          fontSize:       '0.875rem',
          color:          'var(--color-text-secondary)',
          textDecoration: 'none',
          marginBottom:   '3rem',
          letterSpacing:  '0.02em',
        }}>
          ← TRLR
        </Link>

        {/* Heading */}
        <h1 style={{
          fontFamily:    'var(--font-display)',
          fontSize:      'clamp(2rem, 5vw, 3rem)',
          fontWeight:    400,
          color:         'var(--color-text-primary)',
          margin:        '0 0 2.5rem',
          letterSpacing: '0.02em',
        }}>
          About
        </h1>

        {/* Mission */}
        <section style={{ marginBottom: '4rem' }}>
          {ABOUT_PARAGRAPHS.map(paragraph => (
            <p key={paragraph} style={bodyText}>{paragraph}</p>
          ))}
        </section>

        <hr style={{ borderColor: 'var(--color-input-border)', marginBottom: '4rem', borderTop: '1px solid' }} />

        {/* Team */}
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={sectionHeading}>Team</h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {TEAM.map(({ name, role, line }) => (
              <li key={name} style={{ marginBottom: '1.75rem' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.75rem', marginBottom: '0.25rem' }}>
                  <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.125rem', color: 'var(--color-text-primary)' }}>
                    {name}
                  </span>
                  <span style={{ fontFamily: 'var(--font-body)', fontSize: '0.8125rem', color: 'var(--color-text-secondary)', letterSpacing: '0.03em' }}>
                    {role}
                  </span>
                </div>
                <p style={{ ...bodyText, margin: 0, fontSize: '0.9375rem' }}>{line}</p>
              </li>
            ))}
          </ul>
        </section>

        <hr style={{ borderColor: 'var(--color-input-border)', marginBottom: '4rem', borderTop: '1px solid' }} />

        {/* Directions */}
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={sectionHeading}>What we’re building</h2>
          {DIRECTIONS.map(({ name, desc }) => (
            <div key={name} style={{ marginBottom: '2rem' }}>
              <h3 style={{
                fontFamily: 'var(--font-display)',
                fontSize:   '1.125rem',
                fontWeight: 400,
                color:      'var(--color-text-primary)',
                margin:     '0 0 0.5rem',
              }}>
                {name}
              </h3>
              <p style={{ ...bodyText, margin: 0 }}>{desc}</p>
            </div>
          ))}
        </section>

        <hr style={{ borderColor: 'var(--color-input-border)', marginBottom: '3rem', borderTop: '1px solid' }} />

        {/* Contact */}
        <h2 style={sectionHeading}>{CONTACT.heading}</h2>
        <p style={bodyText}>{CONTACT.description}</p>
        <p style={{ ...bodyText, margin: 0 }}>
          <a href={`mailto:${CONTACT.email}`} style={{ color: 'var(--color-accent)', textDecoration: 'none' }}>
            {CONTACT.email}
          </a>
        </p>
        <p style={{ ...bodyText, margin: '2rem 0 0' }}>{CONTACT.closing}</p>
      </div>

      <Navbar />
    </div>
  );
}

const bodyText = {
  fontFamily:  'var(--font-body)',
  fontSize:    '1rem',
  lineHeight:  1.75,
  color:       'var(--text)',
  marginBottom: '1.25rem',
};

const sectionHeading = {
  fontFamily:    'var(--font-display)',
  fontSize:      '1.375rem',
  fontWeight:    400,
  color:         'var(--color-text-primary)',
  margin:        '0 0 1.75rem',
  letterSpacing: '0.02em',
};
